function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M59.88,54.72h-8V25.29L38.12,54.72H30.59L16,24.68v30h-8v-48h8.14L34.29,44,51.74,6.75h8.14Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.89,6.82v47.9h-8v-20H132v20h-8V6.82h8V26.66h19.91V6.82Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.48,49.18l-2,5.54h-8.62L191.9,5.45l19.16,49.27h-8.62l-2.12-5.54-2.6-6.92L191.9,25.64l-5.82,16.62Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.16,49l-2,5.54H72.48L91.58,5.28l19.16,49.27h-8.63L100,49l-2.6-6.91L91.58,25.47,85.76,42.1Z"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cdfdea3f.svg";
export { ForwardRef as ReactComponent };